import {createContext} from 'react';

import type {EagGridStore} from './createEagGridStore';

/**
 * React context that holds the `EagGridStore` instance for the current grid.
 *
 * Access it via `useEagGridStore()` — do **not** consume this context directly.
 * A `null` default value is intentional: `useEagGridStore` will throw a
 * descriptive error if a component attempts to read the store outside a provider.
 */
export const EagGridStoreContext = createContext<EagGridStore | null>(null);
